export default __webpack_public_path__ + "static/media/corners.d6068682.svg";